module.exports = {
    customer: 'sprachtechnik',
    sms_mode: true,
    assets: { logo: 'logo.svg' }
};